import React, { useEffect, useState } from 'react'

import styles from './index.module.css'

type Variant = 'success' | 'error'

type Props = {
  message: string | null
  variant: Variant
  onClose: () => void
}

const AUTO_DISMISS_MS = 5000

type Displayed = { message: string; variant: Variant }

export const Snackbar: React.FC<Props> = ({ message, variant, onClose }) => {
  // 退場アニメ中に message=null になっても描画を継続するための退避。
  const [snapshot, setSnapshot] = useState<Displayed | null>(null)

  // message があればそれを優先（初回 render から表示）、null なら snapshot で退場アニメ。
  const displayed: Displayed | null = message ? { message, variant } : snapshot
  const isExiting = !message && !!snapshot

  useEffect(() => {
    if (message) setSnapshot({ message, variant })
  }, [message, variant])

  useEffect(() => {
    if (!message) return
    const timer = setTimeout(onClose, AUTO_DISMISS_MS)
    return () => clearTimeout(timer)
  }, [message, onClose])

  const handleAnimationEnd = () => {
    if (isExiting) setSnapshot(null)
  }

  if (!displayed) return null

  const toastClass = displayed.variant === 'success' ? styles.toastSuccess : styles.toastError
  const wrapperClass = `${styles.wrapper} ${
    isExiting ? styles.wrapperExiting : styles.wrapperEntering
  }`

  return (
    <div className={wrapperClass} onAnimationEnd={handleAnimationEnd}>
      <div className={`${styles.toast} ${toastClass}`}>
        <span className={styles.message}>{displayed.message}</span>
        <button className={styles.closeButton} onClick={onClose} aria-label="閉じる">
          &times;
        </button>
      </div>
    </div>
  )
}
